import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['F'] as const;

const validator = AbstractMeasurement.nomOptionalMinMax
    .extend({
        unit: z.literal('F').default('F'),
    })
    .default({});

export const Capacitance = {
    validator,
    units,
};

export type Capacitance = z.infer<typeof validator>;
